import { ProcessProcessStatusEnum } from '../../../../db';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import z from 'zod';

// used by work instruction processes when work instructions are being displayed in advanced mode
export const advancedProcessDisplaySchema = z.object({
    processName: z.string(),
    kind: z.literal('advanced'),
    failedCount: z.number().min(0),
    // NOTE: required count can be null if the process solve failed and no spec was choosen
    requiredCount: z.number().min(0).nullable(),
    completedCount: z.number().min(0),
    status: z.nativeEnum(ProcessProcessStatusEnum),
});

const simpleDisplayProcessSchema = z.object({
    kind: z.literal('simple'),
    processId: z.string(),
    materialIdControlVariable: z.string(),
});

export const displayProcessCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('displayProcess'),
    attrs: cellCfgAttrsBaseSchema.extend({
        processData: z.discriminatedUnion('kind', [
            advancedProcessDisplaySchema,
            simpleDisplayProcessSchema,
        ]),
    }),
});

export type MaterialStateDataPayload = {
    status: string;
    processName: string;
    failedCount: number;
    passedCount: number;
    requiredCount: number | null;
};
